export function getSkeletonWidth(
  labelSize: number,
  intervals: {
    max: number
    w: number
  }[],
  fixedWidth: number
) {
  const skeletonWidth = intervals.find((interval) => labelSize >= interval.max)
  return skeletonWidth ? skeletonWidth.w : fixedWidth
}
